import { parse } from "date-fns";
import { TIME_FORMAT } from "@/constants";

export const parseTimeToDate = (timeString: string): Date =>
  parse(timeString, TIME_FORMAT, new Date());
